import React from "react";
import { object } from "prop-types";
import { Link } from "react-router-dom";
import NonverbalImmediacyIndex from "./NonverbalImmediacyTestIndex";
import Big5PersonalityTestIndex from "./Big5PersonalityTestIndex";
import ExposureBasedMemoryTestIndex from "./ExposureBasedMemoryTestIndex";
import DiscAssessmentTestIndex from "./DiscAssessmentTestIndex";

const MyTests = ({ appData }) => {
  const testList = [];
  testList.push(
    <div>
      <Big5PersonalityTestIndex appData={appData} />
      <DiscAssessmentTestIndex appData={appData} />
      <ExposureBasedMemoryTestIndex appData={appData} />
      <NonverbalImmediacyIndex appData={appData} />
    </div>
  );
  return (
    <div className="row justify-content-center" style={{ minHeight: "60vh" }}>
      <div className="col-sm-9 col-lg-8 p-2">
        <h2 className="section-header">My tests</h2>
        <section className="section-body p-1">
          <p className="mb-2">
            Please see below a range of psychometric tests for you to complete.
            Once each test is completed you are able to download a report of
            your results.
          </p>
          {testList && testList.length !== 0 ? (
            <div>
              <Big5PersonalityTestIndex appData={appData} />
              <DiscAssessmentTestIndex appData={appData} />
              <ExposureBasedMemoryTestIndex appData={appData} />
              <NonverbalImmediacyIndex appData={appData} />
            </div>
          ) : (
            <article>
              <h4>No tests have been added yet</h4>
              <p>Important and useful tests can be added to this page.</p>
              <p>
                If you are looking for something specific, please contact your
                HRGO consultant.
              </p>
            </article>
          )}
        </section>
        <div className="d-flex justify-content-end">
          <Link
            to="/profile"
            style={{ minWidth: "175px" }}
            className="btn btn-outline-dark text-dark col-12 col-sm-3 col-lg-2 my-2 hover-text-white"
          >
            Back to My Account
          </Link>
        </div>
      </div>
    </div>
  );
};
MyTests.propTypes = {
  appData: object,
};
export default MyTests;
